// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import getQuotesCollection from "@bg/App/Handlers/CustomQuote/GetCustomQuotesCollection";
import { createCustomQuote, CreateNewQuote } from "@bg/App/Services/CustomQuoteService";
import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

interface Props {
    apiParameter: CreateNewQuote;
    apiResult: { successful: boolean; error?: any };
}

type Parameter = CreateNewQuote & {
    onComplete?: (result: any) => void;
    onSuccess?: () => void;
    onError?: (e: any) => void;
};

type HandlerType = Handler<Parameter, Props>;

export const BeginLoadingquotes: HandlerType = props => {
    props.dispatch({
        type: "Pages/MyCustomQuotes/BeginLoadingQuotes",
    } as any);
};

export const DispatchBeginAction: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const CallApiWithParameters: HandlerType = async props => {
    props.apiResult = await createCustomQuote(props.apiParameter);
};

export const OnError: HandlerType = props => {
    if (!props.apiResult.successful) {
        props.dispatch({
            type: "Pages/MyCustomQuotes/CompleteLoadingQuotes",
        } as any);
        props.parameter.onError?.(props.apiResult.error);
    }
};

export const CallOnComplete: HandlerType = props => {
    if (props.apiResult.successful && props.parameter.onComplete) {
        props.dispatch(getQuotesCollection({} as any));
    }
};

export const chain = [BeginLoadingquotes, DispatchBeginAction, CallApiWithParameters, OnError, CallOnComplete];

const createQuote = createHandlerChainRunner(chain, "CreateQuote");
export default createQuote;
